import { html, LitElement, css, unsafeCSS } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

import '../components/discorduser';

import style from './ladder.scss';
import { isTouchDevice, loadURLParams, setTitle } from '../shared/utils';
import { trackPage } from '../shared/utils';
export class LadderPage extends LitElement {

    static get properties() {
        return {
            ladder: Object
        }
    }

    constructor() {
        super();
        this.ladder = null;        
        this.top = '';
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        let params = {            
            top: ''
        };
        loadURLParams(params);        
        this.top = params.top;   
        setTitle('Player Ladder');
        this.fetchData();
    }

    async fetchData() {
        let res = await fetch(`./api/playerladder?top=${this.top}`);
        if (res.status === 200) {
            this.ladder = await res.json();
        }
    }

    updateURL(){        
        if(window.history){                        
            window.history.replaceState(null, document.title, `./ladder?top=${this.top}`);
            window.dispatchEvent(new PopStateEvent('popstate'));
        }
    }

    renderUser(user,i) {                        
        return html`<div class="line">
            <div class="bubble big" style="${isTouchDevice() ? `position: absolute;
right: 5px;`: ''}">#${i+1}</div>
            <discorduser-component user=${user._id}></discorduser-component>
            <div style=${styleMap(!isTouchDevice() ? {
            'position': 'absolute',
            'right': '10px',
            'top': '20px',
            'text-align':'right',
            'font-weight': 'bold'      
        } : { 'padding-top': '5px'})}>
                🏆 ${user.total?.toLocaleString()}         
            </div>
        </div>`;
    }

    render() {
        if (!this.ladder)
            return html`Crunching the numbers....`;
        return html`
            <h1>Player Ladder</h1>
            <p>Note: This data is aggregated from submitted decks from Discord and Blightbane. Only runs where 4 or more bosses have been slain are counted. Bonus points have been removed.</p>   
            <select @change=${(ev)=>{
                    this.top = ev.target.value;      
                    this.updateURL();              
                    this.fetchData();
                }}>
                <option value="">-- Top --</option>
                ${[20,50,100].map((val)=>{                    
                    return html`<option value="${val}" ?selected=${+this.top === val}>Top ${val}</option>`;
                })}
            </select>    
            ${this.ladder?.map((usr,i) => html`
                ${this.renderUser(usr,i)}
            `)}
        `;
    }
}

customElements.define('ladder-page', LadderPage);